import { createButton, createElement } from "./dom";
import { MONSTERS_ENABLED } from "../game/GameConfig";

export interface MainMenuActions {
  readonly onProceduralRun: () => void;
  readonly onContinue: () => void;
  readonly onSettings: () => void;
  readonly onControls: () => void;
}

export class MainMenu {
  public readonly element = createElement("section", "screen menu-screen");
  private readonly continueButton: HTMLButtonElement;

  public constructor(actions: MainMenuActions) {
    const eyebrow = createElement("div", "eyebrow", "ОРБИТАЛЬНАЯ БЕЗОПАСНОСТЬ / ИНЦИДЕНТ 17");
    const title = createElement("h1", "game-title", "ИНФЕРНАЛЬНЫЙ ПРОРЫВ");
    const subtitle = createElement(
      "p",
      "menu-subtitle",
      MONSTERS_ENABLED
        ? "УНИЧТОЖЬТЕ ТИРАНА. НАЙДИТЕ ВЫХОД ИЗ БЕЗДНЫ."
        : "ИССЛЕДУЙТЕ ПОДЗЕМЕЛЬЕ. НАЙДИТЕ ТАЙНИК И ВЫХОД.",
    );
    const buttons = createElement("nav", "menu-actions");
    buttons.append(createButton("СПУСК В БЕЗДНУ", actions.onProceduralRun));
    this.continueButton = createButton("ПРОДОЛЖИТЬ", actions.onContinue);
    buttons.append(this.continueButton);
    buttons.append(createButton("НАСТРОЙКИ", actions.onSettings));
    buttons.append(createButton("УПРАВЛЕНИЕ", actions.onControls));
    buttons.append(createButton("АВТОРЫ", () => this.togglePanel("credits")));

    const credits = createElement("div", "menu-info hidden");
    credits.dataset["panel"] = "credits";
    credits.innerHTML =
      "<strong>АВТОРЫ</strong><br>Код, процедурная графика и звуковое оформление созданы специально для «Инфернального прорыва». Сведения об использованных звуках CC0 находятся в составе проекта.";
    const footer = createElement("div", "menu-footer", "ОДИН БОЕЦ // ПРОЦЕДУРНЫЙ КОМПЛЕКС 64 × 64");

    const identity = createElement("div", "menu-identity");
    identity.append(eyebrow, title, subtitle);
    const terminal = createElement("div", "menu-terminal");
    terminal.append(
      createElement("div", "terminal-heading", "ДОСТУП К КОМПЛЕКСУ"),
      buttons,
      credits,
    );
    const seal = createElement("div", "breach-seal");
    seal.setAttribute("aria-hidden", "true");
    seal.append(createElement("span", undefined, "17"));
    this.element.append(seal, identity, terminal, footer);
  }

  public setCanContinue(canContinue: boolean): void {
    this.continueButton.disabled = !canContinue;
  }

  public show(): void {
    this.element.classList.remove("hidden");
  }

  public hide(): void {
    this.element.classList.add("hidden");
  }

  private openPanel(name: string): void {
    for (const panel of this.element.querySelectorAll<HTMLElement>("[data-panel]")) {
      panel.classList.toggle("hidden", panel.dataset["panel"] !== name);
    }
  }

  private closePanel(name: string): void {
    this.element.querySelector<HTMLElement>(`[data-panel="${name}"]`)?.classList.add("hidden");
  }

  private togglePanel(name: string): void {
    const panel = this.element.querySelector<HTMLElement>(`[data-panel="${name}"]`);
    if (panel?.classList.contains("hidden")) this.openPanel(name);
    else this.closePanel(name);
  }
}
